import { UPDATE_SUBMENU_PAGE } from "../constants";

const initialState = null;

export const setSubMenuPageData = (data) => ({
    type: UPDATE_SUBMENU_PAGE,
    data,
});

export const subMenuPage = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_SUBMENU_PAGE:
            return action.data;
        default:
            return state;
    }
};
